<motif-button-group>
  <button
    motifButton
    size="small"
    (click)="toggleTheme(false)"
    [disabled]="!isDarkTheme"
    [ngClass]="{ active: !isDarkTheme }"
    aria-label="Light theme">
    <motif-icon [iconFunction]="lightIcon" />
    {{ 'common.theme.light' | translate }}
  </button>
  <button
    motifButton
    size="small"
    (click)="toggleTheme(true)"
    [disabled]="isDarkTheme"
    [ngClass]="{ active: isDarkTheme }"
    aria-label="Dark theme">
    <motif-icon [iconFunction]="darkIcon" />
    {{ 'common.theme.dark' | translate }}
  </button>
</motif-button-group>
